var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sensitive-word-wrapper"},[_c('SensitiveWordsClassify',{attrs:{"data":_vm.initData}}),(_vm.groupsListData.length > 0 && !!_vm.initData)?_c('ClassifyDetail',{attrs:{"data":_vm.initData}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }